import { Link } from '@chakra-ui/core'
import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

function NavLink({ children, to, ...props }) {
  return (
    <Link
      as={RouterLink}
      to={to}
      _hover={{
        textDecoration: 'none',
      }}
      {...props}
    >
      {children}
    </Link>
  )
}

export default NavLink
